import { render } from "./SupplierReturnDetails.vue?vue&type=template&id=20bdb0ca"
import script from "./SupplierReturnDetails.vue?vue&type=script&lang=js"
export * from "./SupplierReturnDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__